export default class Logo {
    constructor(
        readonly id: string,
        readonly name: string,
        readonly imgResourceKey: string,
    ) {}
}
